import {
  GETPROVIDERSADMIN_SUCCESS,
  GETPROVIDERSADMIN_FAILED,
  RESET_GETPROVIDERSADMIN,
  LOADING_GETPROVIDERSADMIN,
  NETWORK_ERROR_GETPROVIDERSADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetProviderSList = () => {
  return { type: RESET_GETPROVIDERSADMIN };
};

const getProviderSList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETPROVIDERSADMIN });
    await adminServices
      .post("getProviders", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(adminGetProviderSsuccess(res.data));
            break;
          default:
            dispatch(adminGetProviderSFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETPROVIDERSADMIN,
          payload: err,
        });
      });
  };

function adminGetProviderSsuccess(data) {
  return {
    type: GETPROVIDERSADMIN_SUCCESS,
    payload: data,
  };
}
function adminGetProviderSFailed(data) {
  return {
    type: GETPROVIDERSADMIN_FAILED,
    payload: data,
  };
}

export { getProviderSList, resetAdminGetProviderSList };
